module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/custom_behavior'));
};
